import type { InvestigationHistoryFiltersType } from "#src/batteries-included-components/FilterAreas/InvestigationHistoryFilterAreas";
import type { InvestigationGetListFiltersType } from "@validereinc/domain";

/**
 * Maps the history-panel filters to investigation search API filters.
 * Plain string values are converted to `$like` by `getFilterObject` in the adapter,
 * matching workflow template name search. The status selection is sent as an
 * array (`$in`); no selection omits it so the API returns only active
 * investigations.
 */
export const buildInvestigationHistorySearchFilters = ({
  title,
  status,
}: InvestigationHistoryFiltersType = {}):
  | InvestigationGetListFiltersType
  | undefined => {
  const trimmedSearchQuery = title?.trim();
  const selectedStatuses = Array.isArray(status) ? status : [];
  const filters: InvestigationGetListFiltersType = {};

  if (trimmedSearchQuery) {
    filters.title = trimmedSearchQuery;
  }

  if (selectedStatuses.length) {
    filters.status = selectedStatuses;
  }

  if (!Object.keys(filters).length) {
    return undefined;
  }

  return filters;
};
